const fields = [
  {
    label: 'Nama Penjadwalan',
    key: 'name',
    isSortable: true,
    isRedirectable: true,
    tdAttr: {
      style: 'left:55px;position:sticky;min-width:250px;max-width:250px',
    },
    thAttr: {
      style: 'left:55px;position:sticky;min-width:250px;max-width:250px;z-index:1;',
    },
  },
  {
    label: 'Status',
    key: 'status.Name',
    tdAttr: {
      style: 'left:305px;min-width:190px;position:sticky;',
    },
    thAttr: {
      style: 'left:305px;min-width:190px;position:sticky;z-index:1;',
    },
  },
  {
    label: 'Jadwal',
    key: 'recurrence',
  },
  {
    label: 'Tanggal Mulai',
    key: 'start_date',
    isSortable: true,
  },
  {
    label: 'Tanggal Berakhir',
    key: 'end_date',
    isSortable: true,
  },
  {
    label: 'Jadwal Selanjutnya',
    key: 'next_run',
  },
]

export default fields
